module.exports = __webpack_public_path__ + "img/Skirt-Back-B2-Da-Fc-Gd-Hc-Ia.185be7c1.png";